import { useQuery } from '@tanstack/react-query';

import { useGuidance } from '@/entities/practice-member';
import { sessionByIdOptions } from '@/entities/session';
import {
    formatNote,
    NOTE_COPY_INTRO_GUIDANCE_KEYS,
    useIsGenerating,
} from '@/entities/session-note';
import { isNotEmpty } from '@/shared/lib/object-utils';

export function useNoteCopyIntro(sessionId: string) {
    const { data: session } = useQuery(sessionByIdOptions(sessionId));
    const isGenerating = useIsGenerating(sessionId);

    const { shouldShow, dismiss } = useGuidance();
    const showSoap = shouldShow(NOTE_COPY_INTRO_GUIDANCE_KEYS.SOAP);
    const showNesso = shouldShow(NOTE_COPY_INTRO_GUIDANCE_KEYS.NESSO);

    const noteType = session?.currentNote?.type;
    const hasContent = isNotEmpty(session?.currentNote?.content);
    const noteText = formatNote(session);

    const isTypeEligible =
        (noteType === 'SOAP' && showSoap && showNesso) || (noteType === 'NESSO' && showNesso);

    const isOpen = isTypeEligible && !isGenerating && hasContent && noteText !== null;

    const onDismiss = () => {
        if (!noteType) return;

        dismiss(NOTE_COPY_INTRO_GUIDANCE_KEYS[noteType]);

        if (noteType === 'NESSO') {
            dismiss(NOTE_COPY_INTRO_GUIDANCE_KEYS.SOAP);
        }
    };

    return { isOpen, noteText, onDismiss };
}
